"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const Fade_1 = __importDefault(require("@material-ui/core/Fade"));
const Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
const CancelButton_1 = require("../Button/CancelButton");
const PrimaryButton_1 = require("../Button/PrimaryButton");
const CriticalButton_1 = require("../Button/CriticalButton");
const useStyles = (0, core_1.makeStyles)(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        overflow: 'scroll',
    },
    modalHeaderText: {
        fontWeight: components_1.StyleVariables.fonts.weight.medium,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h5,
    },
    modalCloseButton: {
        float: 'right',
        color: components_1.StyleVariables.colors.grey4,
        alignSelf: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    modalHeader: {
        backgroundColor: components_1.StyleVariables.colors.grey2,
        borderRadius: '8px 8px 0 0',
        justifyContent: 'space-between',
        padding: '16px 24px',
    },
    modalBody: {
        margin: '24px 24px 54px 24px',
        width: 540,
    },
    modalCancelButton: {
        marginRight: 9,
    },
    paper: {
        width: 640,
        borderRadius: 8,
        maxHeight: 640,
    },
    modalFooter: {
        padding: 16,
        borderTop: `1px solid ${components_1.StyleVariables.colors.grey2}`,
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));
const CustomModal = ({ id, headerText, onHide, closeIcon, modalBody, primaryButtonText, danger, onPrimaryAction, modalFooter, disablePrimaryButton, isValidating, open, }) => {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Modal, { "aria-labelledby": id, open: open, onClose: onHide, className: classes.modal, closeAfterTransition: true, BackdropComponent: Backdrop_1.default, BackdropProps: {
            timeout: 300,
        }, "data-testid": id },
        react_1.default.createElement(Fade_1.default, { in: open },
            react_1.default.createElement(core_1.Paper, { elevation: 0, className: classes.paper },
                react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column" },
                    react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "row", className: classes.modalHeader },
                        react_1.default.createElement(components_1.Text, { as: "h5", className: classes.modalHeaderText }, headerText),
                        closeIcon ?? (react_1.default.createElement(Close_1.default, { onClick: onHide, className: classes.modalCloseButton }))),
                    react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", className: classes.modalBody }, modalBody &&
                        (isValidating ? (react_1.default.createElement(core_1.CircularProgress, { style: { alignSelf: 'center' } })) : (modalBody))),
                    modalFooter ?? (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "row", className: classes.modalFooter },
                        react_1.default.createElement(CancelButton_1.CancelButton, { onClick: onHide, className: classes.modalCancelButton }),
                        danger ? (react_1.default.createElement(CriticalButton_1.CriticalButton, { onClick: onPrimaryAction, text: primaryButtonText, ariaLabel: primaryButtonText, disabled: disablePrimaryButton || isValidating })) : (react_1.default.createElement(PrimaryButton_1.PrimaryButton, { onClick: onPrimaryAction, text: primaryButtonText, ariaLabel: primaryButtonText, disabled: disablePrimaryButton || isValidating, id: "submitButton" })))))))));
};
exports.default = CustomModal;
